import React from 'react'
import Image from '@/components/base/image'
import { AsgTeamCard, AsgTeamListProps } from './types'
import { Column, Row } from '@/components/base/gridview'

const AsgTeamList: React.FunctionComponent<AsgTeamListProps> = (props) => {
  const data = props?.data?.map((item, index) => ({
    ...item,
    isReverse: index % 2 !== 0,
  }))
  const TextContent = (itemData: AsgTeamCard) => {
    return (
      <div className="text-wrapper">
        <span className="name-surname">
          {itemData.nameStatus} {itemData.name} <b>{itemData.surname}</b>
        </span>
        <span className="title">{itemData.title}</span>
        {/* <p style={{ textAlign: itemData.isReverse ? 'right' : 'left' }}>
          <div dangerouslySetInnerHTML={{ __html: itemData.description }} />
        </p> */}
      </div>
    )
  }
  const ImageContent = (itemData: AsgTeamCard) => {
    return <Image alt="" {...itemData.image} style={{ borderRadius: '30px' }} />
  }

  return (
    <div className="team-list">
      <Row
        className="team-item-wrapper"
        gutter="md"
        justify="center"
        align="center"
      >
        {data?.map((item, index) => (
          <Column
            key={index}
            className="column"
            xs={{ size: 12 }}
            sm={{ size: 12 }}
            xl={{ size: 12 }}
          >
            <div className="item">
              <ImageContent {...item} />
              <TextContent {...item} />
            </div>
          </Column>
        ))}
      </Row>
    </div>
  )
}

export default AsgTeamList
